import { TFunction } from 'next-i18next';
import { LOCALE_SEARCH_PATHS } from 'types/locales';

export default function formatPriceRange(min: number | string | null, max: number | string | null, t?: TFunction) {
  if (min && max) {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_PRICE_RANGE, { 
      defaultValue: '{{min}} - {{max}}',
      min: formatPrice(min), 
      max: formatPrice(max), 
    });
  } else if (min && !max) {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_ABOVE_PRICE, { 
      defaultValue: 'Above {{price}}',
      price: formatPrice(min), 
    });
  } else if (!min && max) {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_BELOW_PRICE, { 
      defaultValue: 'Below {{price}}',
      price: formatPrice(max), 
    });
  } else {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_ANY_PRICE, { defaultValue: 'Any Price' });
  }
}
export const formatSqftRange = (min: number | string | null, max: number | string | null, t?: TFunction) => {
  if (min && max) {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_SQFT_RANGE, { 
      defaultValue: '{{min}} - {{max}} Sqft',
      min: min, 
      max: max, 
    });
  } else if (min && !max) {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_ABOVE_SQFT, { 
      defaultValue: 'Above {{sqft}} Sqft',
      sqft: min, 
    });
  } else if (!min && max) {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_BELOW_SQFT, { 
      defaultValue: 'Below {{sqft}} Sqft',
      sqft: max, 
    });
  } else {
    return t(LOCALE_SEARCH_PATHS.FILTER_LABELS_SQUARE_FEET, { defaultValue: 'Square Feet' });
  }
};

function formatPrice(value: number | string) {
  if (typeof value === 'number') {
    value = value.toFixed();
  }
  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  value = value.replace(/[^\d,]/g, '');
  const prefix = value.slice(0, 4).replace(',', '.').replace(/(\.[^0]*?)0+$/, '$1').replace(/\.$/, '');
  const partsCount = value.split(',').length;
  const suffix = partsCount === 1 ? '' : (partsCount === 2 ? 'K' : 'M');
  return `${prefix}${suffix}`;
}
